import { formatCompanyMessageFlowText } from 'src/modules/onboarding/helpers/workflowBuilder';
import { CompanyCampaignInfoInputBody } from '../types';

export const COMPANY_PHONE_NUMBER_PLACEHOLDER = '{{companyPhoneNumber}}';

export const buildHelpMessage = (companyName: string, email?: string): string => {
  if (!email) {
    return '';
  }

  return `For help from ${companyName}, please reach out to ${email}.`;
};

export const getHelpMessage = (
  helpMessage: string | undefined,
  companyName: string,
  email?: string,
): string => helpMessage || buildHelpMessage(companyName, email);

export const buildDefaultCampaignInfoPayload = (
  companyName: string,
  phoneNumber: string | undefined,
  contactEmail: string | undefined,
  usecase: string,
  subUsecases: string[],
  flyerLink = '',
): CompanyCampaignInfoInputBody => {
  const optinMessage = formatCompanyMessageFlowText(companyName, usecase, subUsecases);
  const resolvedPhone = phoneNumber || COMPANY_PHONE_NUMBER_PLACEHOLDER;

  const description =
    `${companyName} will send messages to membership based on recipients opting-in from a flyer that is visible inside of their office. ` +
    `Here is a link to the flyer: {{flyerLink}}`;

  const messageFlow =
    `Recipients opt-in to the ${companyName} text program by texting in the keyword "START" to ${resolvedPhone}. ` +
    `They can see the the flyer that is visible inside of their office. Here is link to the flyer: {{flyerLink}}\n\n` +
    `The response they will receive upon opt-in is: ${optinMessage}\n\n` +
    `Message Privacy Policy: We do not sell, rent, loan, trade, lease, or otherwise transfer any phone number or personal data received through the program to any third party.`;

  return {
    usecase,
    subUsecases,
    resellerId: 'R000000',
    description,
    messageFlow,
    flyerLink,
    privacyPolicyLink: '{{flyerLink}}',
    termsAndConditionsLink: '{{flyerLink}}',
    sample1: optinMessage,
    sample2: `Thanks for joining ${companyName}. Reach out with any questions! Reply HELP for Help or STOP to Opt-out anytime. Msg and data rates may apply. Msg frequency may vary.`,
    sample3: undefined,
    sample4: undefined,
    sample5: undefined,
    subscriberHelp: true,
    subscriberOptin: true,
    subscriberOptout: true,
    helpMessage: getHelpMessage('', companyName, contactEmail),
    helpKeywords: 'HELP',
    optinKeywords: 'START',
    optoutKeywords: 'STOP',
    optinMessage,
    optoutMessage: `You are now opted-out of the ${companyName} and no further messages will be sent.`,
    mock: false,
  };
};
